<script lang="ts" setup>
import { useTemplateRef } from '#imports';
import type { AudioMsgVO } from '@core/types/im';
import { READ_STATUS } from '../../constant';
import ImAudioRadar from './ImAudioRadar.vue';
import ImMsgBase from './ImMsgBase.vue';

interface Props {
  msg: AudioMsgVO;
}

const { msg } = defineProps<Props>();
const audioRadarRef = useTemplateRef('audio-radar');
const emit = defineEmits(['retry', 'read']);

function handleRetry() {
  emit('retry');
}
function handleRead() {
  emit('read', READ_STATUS.READ_AND_PLAY);
}

function handleToggleAudio() {
  handleRead();
  audioRadarRef.value?.toggleAudio();
}
</script>

<template>
  <ImMsgBase
    :recall="msg.msgBody.recall"
    :avatar="msg.avatar"
    :show-datetime="msg.showDatetime"
    :time="msg.msgTime"
    :placement="msg.placement"
    :loading="msg.loading"
    :error="msg.error"
    :unread="msg.readStatus === 0 && !msg.isMine"
    @retry="handleRetry"
  >
    <div class="cursor-pointer" @click="handleToggleAudio">
      <div class="flex-center">
        <ImAudioRadar ref="audio-radar" :url="msg.msgBody.audioMsg.url" />
        <div class="text-font1 ml-2.5 text-sm">
          {{ msg.msgBody.extra.audioLen }}s
        </div>
      </div>
    </div>
  </ImMsgBase>
</template>

<style scoped>
:deep(.im-msg-content-wrapper .im-msg-content) {
  padding-top: 9px;
  padding-bottom: 9px;
}
</style>
